// @ts-nocheck
/* eslint-disable */

const HeapId = process.env.REACT_APP_HEAP_ID;

function heapScript(id: string) {
  (function () {
    (window.heapReadyCb = window.heapReadyCb || []),
      (window.heap = window.heap || []),
      (heap.load = function (e, t) {
        (window.heap.envId = e),
          (window.heap.clientConfig = t = t || {}),
          (window.heap.clientConfig.shouldFetchServerConfig = !1);
        var a = document.createElement('script');
        (a.type = 'text/javascript'),
          (a.async = !0),
          (a.src = 'https://cdn.us.heap-api.com/config/' + e + '/heap_config.js');
        var r = document.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(a, r);
        var n = [
            'init',
            'startTracking',
            'stopTracking',
            'track',
            'resetIdentity',
            'identify',
            'getSessionId',
            'getUserId',
            'getIdentity',
            'addUserProperties',
            'addEventProperties',
            'removeEventProperty',
            'clearEventProperties',
            'addAccountProperties',
            'addAdapter',
            'addTransformer',
            'addTransformerFn',
            'onReady',
            'addPageviewProperties',
            'removePageviewProperty',
            'clearPageviewProperties',
            'trackPageview',
          ],
          i = function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments, 0);
              window.heapReadyCb.push({
                name: e,
                fn: function () {
                  heap[e] && heap[e].apply(heap, t);
                },
              });
            };
          };
        for (var p = 0; p < n.length; p++) heap[n[p]] = i(n[p]);
      });
    heap.load(id, {
      disableInteractionEvents: ['click', 'submit', 'change'],
      disablePageviewAutocapture: true,
    });
  })();
}

const checkIsHeapInitialized = () => {
  return Boolean(window.heap);
};

class Heap {
  static initialize() {
    if (checkIsHeapInitialized()) return;
    heapScript(HeapId);
  }

  static identify(id: string) {
    if (!checkIsHeapInitialized()) return;
    heap.identify(id);
  }

  static addUserProperties(data: Record<string, string | number>) {
    if (!checkIsHeapInitialized()) return;
    heap.addUserProperties(data);
  }

  static addEventProperties(data: Record<string, string | number>) {
    if (!checkIsHeapInitialized()) return;
    heap.addEventProperties(data);
  }

  static track(
    event: string,
    data?: Record<string, string | number | boolean | undefined>,
  ) {
    if (!checkIsHeapInitialized()) return;
    heap.track(event, data);
  }
}

export {Heap};
